import "antd/es/modal/style";
import _Modal from "antd/es/modal";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import invariant from 'invariant';
import { LocaleContext } from '../locale';
import { useState, useCallback, useRef, useReducer, useContext } from 'react';
import Button from '../button';
import Typography from '../typography';
import { PublishOutlined, CrossOutlined } from 'iglooicon';
import JobList from './job-list';
import { useRequest } from '@umijs/hooks';
import Import from './modal';
import Float from './float';
import debounce from 'lodash.debounce';
import './style';

var AdminUpload = function AdminUpload(_ref) {
  var dataSource = _ref.dataSource,
      requestMethod = _ref.requestMethod,
      uploadMethod = _ref.uploadMethod,
      modalTitle = _ref.modalTitle,
      floatTitle = _ref.floatTitle,
      buttonText = _ref.buttonText,
      buttonType = _ref.buttonType,
      _ref$enableApiAuth = _ref.enableApiAuth,
      enableApiAuth = _ref$enableApiAuth === void 0 ? false : _ref$enableApiAuth,
      _ref$refreshInteval = _ref.refreshInteval,
      refreshInteval = _ref$refreshInteval === void 0 ? 1000 : _ref$refreshInteval,
      accept = _ref.accept,
      formatTips = _ref.formatTips,
      selectPlaceholder = _ref.selectPlaceholder,
      onFinish = _ref.onFinish;
  invariant(dataSource, 'dataSource is required');
  invariant(typeof requestMethod === 'function', 'requestMethod is required');

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showFloat = _useState4[0],
      setShowFloat = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showFloatComfirm = _useState6[0],
      setShowFloatComfirm = _useState6[1];

  var _useReducer = useReducer(function () {
    var jobs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref2.type,
        payload = _ref2.payload;

    switch (type) {
      case 'new':
        {
          return [].concat(_toConsumableArray(jobs), [payload]);
        }

      case 'update':
        {
          return jobs.map(function (job) {
            if (job.uid === payload.uid) {
              return _objectSpread(_objectSpread({}, job), payload);
            }

            return job;
          });
        }

      case 'remove':
        {
          return jobs.filter(function (job) {
            return job.uid !== payload.uid;
          });
        }

      default:
        return jobs;
    }
  }, [], function () {
    return [];
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      uploadJobs = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      processingJobs = _useState8[0],
      setProcessingJobs = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      doneJobs = _useState10[0],
      setDoneJobs = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      failed = _useState12[0],
      setFailed = _useState12[1];

  var uploadRef = useRef({});
  var getJobs = useCallback(function () {
    return requestMethod(enableApiAuth ? '/v2/platform/admin/fileapi/data_file/jobs' : '/v2/admin/fileapi/data_file/jobs', {
      params: {
        data_source_ids: Array.isArray(dataSource) ? dataSource.map(function (_ref3) {
          var value = _ref3.value;
          return value;
        }) : [dataSource]
      },
      errorHandler: function errorHandler() {}
    });
  }, [requestMethod, enableApiAuth]);
  var remove = useCallback(function (jobIds) {
    return requestMethod(enableApiAuth ? "/v2/platform/admin/fileapi/data_file/jobs/hides" : "/v2/admin/fileapi/data_file/jobs/hides", {
      method: 'post',
      data: {
        job_ids: jobIds
      }
    });
  }, [requestMethod, enableApiAuth]);

  var _useRequest = useRequest(getJobs, {
    pollingInterval: refreshInteval,
    pollingWhenHidden: false,
    onSuccess: function onSuccess(_ref4) {
      var _data$sort;

      var data = _ref4.data;
      var processing = [];
      var done = [];
      var latestFinished = [];
      data === null || data === void 0 ? void 0 : (_data$sort = data.sort(function (a, b) {
        return b.create_at - a.create_at;
      })) === null || _data$sort === void 0 ? void 0 : _data$sort.forEach(function (job) {
        if (job.status === 'Done') {
          done.push(job);

          if (!doneJobs.find(function (_ref5) {
            var job_id = _ref5.job_id;
            return job.job_id === job_id;
          })) {
            latestFinished.push(job);
          }
        }

        if (job.status === 'Processing') {
          processing.push(job);
        }
      });
      setProcessingJobs(processing);
      setDoneJobs(done);

      if (latestFinished.length && typeof onFinish === 'function') {
        onFinish(latestFinished);
      }

      setFailed(false);

      if (!(processing === null || processing === void 0 ? void 0 : processing.length)) {
        cancel();
      }

      if ((data === null || data === void 0 ? void 0 : data.length) && !showFloat) {
        setShowFloat(true);
      }

      if (!(data === null || data === void 0 ? void 0 : data.length) && showFloat) {
        setShowFloat(false);
      }
    },
    onError: function onError() {
      return setFailed(true);
    }
  }),
      refresh = _useRequest.run,
      cancel = _useRequest.cancel;

  var handleUploadProgress = function handleUploadProgress(uid, loadedSize, total) {
    dispatch({
      type: 'update',
      payload: {
        uid: uid,
        loadedSize: loadedSize,
        total: total
      }
    });
  };

  var handleUpload = function handleUpload(file, dataSourceId) {
    var uid = file.uid,
        name = file.name,
        size = file.size;
    dispatch({
      type: 'new',
      payload: {
        uid: uid,
        fileName: name,
        fileSize: size,
        loadedSize: 0,
        status: 'uploading',
        originFile: file
      }
    });

    var handleProgress = function handleProgress(e) {
      var lengthComputable = e.lengthComputable,
          loaded = e.loaded,
          total = e.total;

      if (!lengthComputable) {
        return;
      }

      handleUploadProgress(uid, loaded, total);
    };

    var _uploadMethod = uploadMethod(dataSourceId, file, enableApiAuth, handleProgress),
        abort = _uploadMethod.abort,
        result = _uploadMethod.result;

    result.then(function () {
      dispatch({
        type: 'update',
        payload: {
          uid: uid,
          status: 'done'
        }
      });
      refresh().then(function () {
        handleRemoveUpload(uid);
      });
    }).catch(function (_ref6) {
      var errorMessage = _ref6.errorMessage;
      dispatch({
        type: 'update',
        payload: {
          uid: uid,
          errorMessage: errorMessage,
          status: 'failed'
        }
      });
    });
    uploadRef.current[uid] = {
      abort: abort,
      file: file,
      dataSourceId: dataSourceId
    };
  };

  var handleCancelUpload = function handleCancelUpload(uid) {
    uploadRef.current[uid].abort();
    dispatch({
      type: 'remove',
      payload: {
        uid: uid
      }
    });
  };

  var handleReUpload = function handleReUpload(uid) {
    dispatch({
      type: 'remove',
      payload: {
        uid: uid,
        status: 'uploading'
      }
    });
    var _uploadRef$current$ui = uploadRef.current[uid],
        file = _uploadRef$current$ui.file,
        dataSourceId = _uploadRef$current$ui.dataSourceId;
    handleUpload(file, dataSourceId);
  };

  var handleRemoveUpload = function handleRemoveUpload(uid) {
    dispatch({
      type: 'remove',
      payload: {
        uid: uid
      }
    });
  };

  var handleRemoveJob = debounce( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(jobId) {
      var rst;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return remove([jobId]);

            case 2:
              rst = _context.sent;

              if (rst) {
                refresh();
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }(), 2000, {
    leading: true,
    trailing: false
  });

  var handleHideJobs = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var rst;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return remove(doneJobs.map(function (_ref9) {
                var job_id = _ref9.job_id;
                return job_id;
              }));

            case 2:
              rst = _context2.sent;

              if (rst) {
                refresh();
                setShowFloatComfirm(false);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleHideJobs() {
      return _ref8.apply(this, arguments);
    };
  }();

  var handleCloseFloat = function handleCloseFloat(e) {
    e.stopPropagation();
    setShowFloatComfirm(true);
  };

  return _jsxs("div", {
    className: "igloo-admin-upload",
    children: [_jsx(Button, {
      type: buttonType,
      onClick: function onClick() {
        return setShowModal(true);
      },
      icon: _jsx(PublishOutlined, {}),
      children: buttonText || formatMessage({
        id: 'Import'
      })
    }), _jsx(Import, {
      title: modalTitle,
      accept: accept,
      visible: showModal,
      dataSource: dataSource,
      selectPlaceholder: selectPlaceholder,
      onClose: function onClose() {
        return setShowModal(false);
      },
      onUpload: handleUpload,
      children: _jsx(JobList, {
        uploadJobs: uploadJobs,
        processingJobs: processingJobs,
        doneJobs: doneJobs,
        size: "default",
        fetchingFailed: failed,
        cancelUpload: handleCancelUpload,
        reUpload: handleReUpload,
        cancelProcess: handleRemoveJob,
        hideJob: handleRemoveJob
      })
    }), _jsx(Float, {
      title: floatTitle,
      visible: showFloat,
      uploadingNumber: uploadJobs.length,
      processingNumber: processingJobs.length,
      doneNumber: doneJobs.length,
      onClose: handleCloseFloat,
      formatTips: formatTips,
      children: _jsx(JobList, {
        uploadJobs: uploadJobs,
        processingJobs: processingJobs,
        doneJobs: doneJobs,
        size: "small",
        fetchingFailed: failed,
        cancelUpload: handleCancelUpload,
        reUpload: handleReUpload,
        cancelProcess: handleRemoveJob,
        hideJob: handleRemoveJob
      })
    }), _jsx(_Modal, {
      cancelText: formatMessage({
        id: 'Cancel'
      }),
      okText: formatMessage({
        id: 'Yes, Close'
      }),
      title: formatMessage({
        id: 'Close Result Panel'
      }),
      onOk: handleHideJobs,
      visible: showFloatComfirm,
      okButtonProps: {
        style: {
          minWidth: 160
        }
      },
      cancelButtonProps: {
        style: {
          minWidth: 160
        }
      },
      width: 600,
      onCancel: function onCancel() {
        return setShowFloatComfirm(false);
      },
      className: "igloo-admin-upload-confirm",
      closeIcon: _jsx(CrossOutlined, {
        style: {
          fontSize: 24
        }
      }),
      children: _jsxs(Typography, {
        level: "body1",
        children: ["Would you like to close the result panel now? You can go to", ' ', _jsxs(Typography, {
          level: "caption1",
          children: ["My Account ", '>', " Activity Log"]
        }), ' ', "to view this import result after this panel is closed."]
      })
    })]
  });
};

export default AdminUpload;